export default "__VITE_ASSET__fdf09ce1__"